<template>
  <mobile-responsive-shell :title="title">
    <desktop-view />
  </mobile-responsive-shell>
</template>

<script>
import MobileResponsiveShell from "../components/MobileResponsiveShell.vue";
import DesktopView from "@/views/stocks/transferQuantity.vue";

export default {
  name: "MobileStocksTransferQuantity",
  components: {
    MobileResponsiveShell,
    DesktopView,
  },
  data() {
    return {
      title: "Transfert quantité",
    };
  },
};
</script>
